import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Primitives";
import { toast } from "sonner";

export default function StudentAssignments() {
  const [assigns, setAssigns] = useState([]);
  const [content, setContent] = useState({});

  const load = () => api.get("/assignments").then(r => setAssigns(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (id) => {
    if (!content[id]) { toast.error("Write something"); return; }
    try {
      await api.post("/submissions", { assignment_id: id, content: content[id] });
      toast.success("Submitted");
      load();
    } catch { toast.error("Failed"); }
  };

  return (
    <div>
      <PageHeader eyebrow="Descriptive work" title="Assignments" subtitle="Submit descriptive answers for review." />
      {assigns.length === 0 ? <EmptyState title="No assignments yet" /> : (
        <div className="space-y-4">
          {assigns.map(a => {
            const dueDate = new Date(a.due_date);
            const overdue = dueDate < new Date();
            return (
              <div key={a.id} className="card-academic p-6">
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <div className="overline">{a.class_group} · due {dueDate.toLocaleString()}</div>
                    <h4 className="font-serif text-xl text-forest">{a.title}</h4>
                    <p className="text-sm text-mossy mt-1">{a.description}</p>
                  </div>
                  {overdue && !a.submission && <span className="overline text-terracotta">Overdue</span>}
                </div>
                {a.submission ? (
                  <div className="mt-4 p-4 bg-sand/40 border-l-2 border-forest">
                    <div className="overline mb-1">Your submission{a.submission.is_late ? " · late" : ""}</div>
                    <div className="text-sm text-ink whitespace-pre-wrap">{a.submission.content}</div>
                    {a.submission.grade && <div className="mt-2 overline text-forest">Grade: <span className="font-mono text-ink">{a.submission.grade}</span></div>}
                  </div>
                ) : (
                  <div className="mt-3">
                    <textarea rows={4} value={content[a.id] || ""} onChange={e => setContent({ ...content, [a.id]: e.target.value })}
                      data-testid={`sub-text-${a.id}`}
                      className="w-full bg-ivory border border-stone px-4 py-3 mb-2" placeholder="Write your answer…" />
                    <button onClick={() => submit(a.id)} className="btn-primary" data-testid={`sub-btn-${a.id}`}>Submit</button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
